module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-c-nav__cart"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/cart-icon.svg")
    }
  }), _vm._v(" "), (_vm.cartSize > 0) ? _c('div', {
    staticClass: "mxr-c-nav__cart__bullet"
  }, [_vm._v(_vm._s(_vm.cartSize))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ebdb5dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 457
// module chunks = 1